const flatpickr = require('flatpickr')
const module = angular.module('flatpickr', []);

module.directive('flatpickr', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            flatpickrOptions: '<'
        },
        link: function (scope, element, attrs, ngModelCtrl) {
            let fp = null;

            function init() {
                fp = flatpickr(element[0], Object.assign({}, scope.flatpickrOptions || {}, {
                    enableTime: true,
                    time_24hr: true,
                    onChange: function (selectedDates) {
                        scope.$applyAsync(function () {
                            const date = selectedDates.length ? selectedDates[0] : null;
                            ngModelCtrl.$setViewValue(date);
                        });
                    }
                }));

                ngModelCtrl.$render = function () {
                    if (fp) {
                        if (ngModelCtrl.$viewValue == '' || !ngModelCtrl.$viewValue) {
                            fp.clear();
                        } else {
                            fp.setDate(ngModelCtrl.$viewValue, true);
                        }
                    }
                };
            }

            init();

            // Cleanup when the directive is destroyed
            scope.$on('$destroy', () => {
                if (fp) {
                    fp.destroy();
                    fp = null;
                }
            });
        }
    };
});